import {Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpClient } from '@angular/common/http';
import {Observable, switchMap} from 'rxjs';
import {environment} from "../../environments/environment";
import {TargetCompanyService} from "../_services/target-company.service";
import {GlobalStore} from "../global.store";


@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  private currentCompanyId: number | null = null;

  constructor(
    private http: HttpClient,
    private targetCompanyService: TargetCompanyService,
    private globalStore: GlobalStore
  ) {
    this.globalStore.companyId$.subscribe((companyId) => {
      this.currentCompanyId = companyId;
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.serverUrl)) {
      const skipCompanyScope = req.headers.has('X-Skip-Company-Id');
      const headers: Record<string, string> = {'X-Current-URL': window.location.href};
      const companyId = this.targetCompanyService.getRequestCompanyId(req.url)
        ?? this.targetCompanyService.getRequestCompanyId(window.location.href)
        ?? this.currentCompanyId;

      if (!skipCompanyScope && companyId && !req.headers.has('X-Company-Id')) {
        headers['X-Company-Id'] = String(companyId);
      }

      let modifiedReq = req.clone({
        setHeaders: headers
      });

      if (skipCompanyScope) {
        modifiedReq = modifiedReq.clone({
          headers: modifiedReq.headers.delete('X-Company-Id')
        });
      }

      if (environment.csrfEnabled && ['POST', 'DELETE', 'PUT'].includes(req.method)) {
        return this.http
          .get<{ token: string }>(`${environment.serverUrl}/csrf/token`, {withCredentials: true})
          .pipe(
            switchMap((result) => next.handle(modifiedReq.clone({setHeaders: {'X-XSRF-TOKEN': JSON.parse(JSON.stringify(result)).token}})))
          );
      } else {
        return next.handle(modifiedReq);
      }
    } else {
      return next.handle(req);
    }
  }
}

